import * as angular from 'angular';
import './styling.scss';
import * as template from './template.html';

const module = angular.module('fact-cell', []);

interface FactCellController extends angular.IStrictController {
    header: string;
    fact: string;
}

module.component('factCell', {
    template: template,
    bindings: {
        header: '<',
        fact: '<'
    },
    controller: function(this: FactCellController, $element: angular.IAugmentedJQuery) {
        this.$onInit = () => {};
    }
});

export { module };
